export default __webpack_public_path__ + "static/media/weblogo.7ae102e5.png";